/**
 * @description
 * Objeto que define las rutas utilizadas en el módulo de métricas clínicas.
 * Cada propiedad representa una ruta específica para acceder a diferentes métricas
 * y funcionalidades dentro del portal clínico.
 *
 * @property {string} generic - Ruta para métricas genéricas.
 * @property {string} adopt - Ruta para métricas de adopción profesional.
 * @property {string} viewingKeironOrderStatus - Ruta para visualizar el estado de órdenes en Keiron.
 * @property {string} agenda - Ruta para la gestión de agenda profesional.
 * @property {string} futureOffer - Ruta para la oferta futura profesional.
 * @property {string} productivity - Ruta para métricas de productividad profesional.
 * @property {string} qualtrics - Ruta para consultas médicas presenciales y telemedicina.
 */
export const METRICS_ROUTES = {
  generic                 : 'genéricos',
  adopt                   : 'profesional/adopción',
  viewingKeironOrderStatus: 'keiron/estado-ordenes',
  agenda                  : 'profesional/gestion-agenda',
  futureOffer             : 'profesional/oferta-futura',
  productivity            : 'profesional/productividad',
  qualtrics               : 'consultas/medicas/precenciales-y-tlm',
};
